/**
 * Resolves a human-readable label identifying the edited row/element for editor headers.
 * Priority: columnCode -> name -> code -> id. Returns undefined when nothing usable exists.
 */
const LABEL_FIELDS = ['columnCode', 'name', 'code'] as const

export const getRowElementLabel = (row: unknown): string | undefined => {
	if (!row || typeof row !== 'object') {
		return undefined
	}

	const record = row as Record<string, unknown>

	for (const field of LABEL_FIELDS) {
		const value = record[field]
		if (typeof value === 'string' && value.trim() !== '') {
			return value
		}
	}

	const id = record.id
	if (typeof id === 'string' || typeof id === 'number') {
		const idText = String(id)
		return idText === '' ? undefined : idText
	}

	return undefined
}
